<template>
  <div class="flex justify-between h-full w-full">
    <conversation-navigation-buttons-block :steps="steps.slice(0, 2)" @step="handleStep"/>
    <slot/>
    <conversation-navigation-buttons-block :steps="steps.slice(2, 4)" @step="handleStep"/>
  </div>
</template>

<script>
import ConversationNavigationButtonsBlock
  from '@/components/analytics/conversations/detail/ConversationNavigationButtonsBlock.vue'

export default {
  name: 'ConversationNavigationButtons',

  components: {
    ConversationNavigationButtonsBlock
  },

  props: {
    disabledButtons: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    steps() {
      return [
        {
          name: 'previous-conversation',
          component: 'RewindBackIcon',
          disabled: this.disabledButtons.previousConversation
        },
        { name: 'previous-request', component: 'StepBackIcon', disabled: this.disabledButtons.previousRequest },
        { name: 'next-request', component: 'StepForwardIcon', disabled: this.disabledButtons.nextRequest },
        { name: 'next-conversation', component: 'RewindForwardIcon', disabled: this.disabledButtons.nextConversation }
      ]
    }
  },

  methods: {
    handleStep({ disabled, name }) {
      if (disabled) return

      this.$emit(name)
    }
  }
}
</script>

